import React from 'react';
import {Link} from "@reach/router";

const HeroButtons = () => {
  return(
    <div className="pod-hero-buttons d-flex justify-content-start align-items-stretch">
      <div className="pod-hero-button">
        <Link to={'/buyer-signup'} className="btn btn-lg btn-primary">
          Start buying faster
        </Link>
      </div>
    </div>
  );
}

export default HeroButtons;
